/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import { createGetPromptVersionsService } from '../../../../common/prompt/createPromptV2Services';
import * as constants from '../../constants/AgenticServiceConstants';
import { PROMPT_MANAGEMENT_LANG_KEYS } from '../../constants/AgenticPromptMgmtConstants';

export default createGetPromptVersionsService({
  eventName: constants.GET_AGENTIC_PROMPT_VERSIONS,
  statusKey: 'GetAgenticPromptVersionsServiceStatus',
  storeName: 'agenticPromptModel',
  errorLangKey: PROMPT_MANAGEMENT_LANG_KEYS.ERROR_VERSIONS,
  errorEvent: constants.GET_AGENTIC_PROMPT_VERSIONS_ERROR
});
